<template>
  <div>
    <pageTable />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'personal-myResearchFabric',
  components: {
    PageTable,
  },
}
</script>
